module.exports = __webpack_public_path__ + "img/HA1508-177.48c8ddc6.jpg";